import React from "react";
import CodeRain from "../components/CodeRain";
import BackButton from "../components/BackButton";
import "./Bokbubblan.css";
import bokbubblan from "../assets/bokbubblan.png";
import bokbubblankundvagn from "../assets/bokbubblankundvagn.png";

const Bokbubblan = () => {
  return (
    <div className="bokbubblan-page">
      <CodeRain />
      <div className="bokbubblan-content">
        <BackButton label="Back to Projects" />

        <h1>BokBubblan</h1>

        <p>
          BokBubblan is a full-stack e-commerce platform for buying and renting books, built
          from the ground up by a cross-functional development team. The application covers
          the complete purchase lifecycle: product catalogue, cart management, checkout, and
          order confirmation.
        </p>

        <p>
          <strong>Stack:</strong> Java + Spring Boot (REST API and server-side routing), vanilla
          HTML/CSS/JavaScript (frontend). The decision to work without a frontend framework
          kept the architecture lean and required a solid grasp of core web fundamentals -
          HTTP, DOM manipulation, and clean API contract design.
        </p>

        <p>
          My scope covered the full frontend-to-backend integration: product listing views,
          shopping cart state management, REST API consumption, and HTML template design
          across the checkout flow - product pages, cart, and order confirmation.
        </p>

        <p>
          Delivered using an agile workflow with Git branching, code review via GitHub pull
          requests, and sprint reviews - mirroring real-world delivery practices. Clear API
          contracts between frontend and backend, shared ownership, and consistent
          communication were critical to hitting scope.
        </p>

        <h2 style={{ marginTop: "50px" }}>📸 Screenshots</h2>
        <div className="image-row">
          <img src={bokbubblan} alt="BokBubblan homepage" />
          <img src={bokbubblankundvagn} alt="BokBubblan shopping cart" />
        </div>
      </div>
    </div>
  );
};

export default Bokbubblan;
